import React from 'react';
import { css } from '@linaria/core';
import classNames from 'classnames';

const groupWithBackground = css`
  padding: 10px;
  margin-bottom: 10px;
  background: #f9f6f4;
`;

const heading = css`
  color: #1a1a1a;
  font-size: 22px;
  font-weight: 700;
  line-height: 34px;
  margin: 0;
  padding-bottom: 10px;
`;

const fields = css`
  display: block;
`;

export default function FormGroupWithBackground({ children, title }) {
  return (
    <div className={classNames(groupWithBackground)}>
      <h3 className={heading}>{title}</h3>
      <div className={classNames(fields)}>{children}</div>
    </div>
  );
}
